// Polyfills have to be imported before everything else
import 'core-js/es6/reflect'
import 'core-js/es7/reflect'
import 'zone.js/dist/zone.js'

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'
import { UpgradeModule } from '@angular/upgrade/static'

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.then(platformRef => {
		const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule
		upgrade.bootstrap(document.documentElement, ['widgetSitePicker'], { strictDi: true })
		console.log('hybrid widgetSitePicker')
	})
